import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchIntakeCarts, selectIntakeCartState } from "../redux/slices/intakeCartSlice"
import { ApiStatus } from "../types/api/status"
import { IntakeCartAPI } from "../apis/IntakeCartAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useIntakeCartStore = () => {
    const dispatch = useDispatch()
    const { intakeCarts, intakeCartSelected, status } = useSelector(selectIntakeCartState)

    const getIntakeKart = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await IntakeCartAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(onFetchIntakeCarts(detail || []))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createIntakeCart = async (data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await IntakeCartAPI.create(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const updateQuantity = async (id: number, data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await IntakeCartAPI.updateQuantity(id, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteProductCart = async (id: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await IntakeCartAPI.delete(id)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const clearIntakeCart = () => {
        try {
            dispatch(onFetchIntakeCarts([]))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        intakeCarts,
        intakeCartSelected,
        status,
        getIntakeKart,
        createIntakeCart,
        updateQuantity,
        deleteProductCart,
        clearIntakeCart
    }
}